
{
  "fr": {
    "BirthdateForm": {
      "first_name": "Prénom",
      "birthdate": "Date de naissance (JJ/MM/AAAA)",
      "gender": "Genre",
      "relationship": "Lien de parenté",
      "required": "*",
      "remove": "Supprimer cet anniversaire"
    }
  }
}
